module.exports = __webpack_public_path__ + "img/renga-logo-text.e3fc66b1.png";